export const defaultRichTextValue = [
  {
    children: [{ text: '' }],
  },
]
